import React from 'react'
import { MarketCalculusCard } from '../../components/preview/Preview'
import { useTranslation } from 'react-i18next'
import { useDSsummaryTablesData } from '../../store/dataStore'
import { Spinner } from 'reactstrap'
import { BlockBetween, BlockHead, BlockHeadContent, BlockTitle } from '../../components/Component'
import HsTradeTimeMatrix from '../../components/tradeTimeMatrix/HsTradeTimeMatrix'
import { useEndpointStatusData } from '../../store/endpointStatus'
import { REQUEST_STATUSES } from '../mc-components/McPageHelpers'
import { getCountryName } from '../mc-components/market-overview/MarketOverviewTable/MarketOverviewTable.settings'
import { useSDSsearchParams } from '../../store/searchDataStore'
import { useGlobalStoreData } from '../../store/globalStore'
import BadgeCode from '../../components/badge/BadgeCode'
import { BADGE_CODES } from '../../utils/Constants'

const SourceCountryThirdTab = ({ isMonthly }) => {
  const { t } = useTranslation()
  const searchParams = useSDSsearchParams()
  const countriesGSD = useGlobalStoreData.countries()
  const summaryTablesData = useDSsummaryTablesData()
  const comtradeSummaryEndpointStatus = useEndpointStatusData.comtradeSummary()

  const currentTableData = isMonthly ? summaryTablesData?.importTabs?.tab3?.monthly : summaryTablesData?.importTabs?.tab3?.yearly

  if (comtradeSummaryEndpointStatus === REQUEST_STATUSES.REQUESTED) {
    return <MarketCalculusCard>
      <div className="d-flex flex-row justify-content-center align-items-center my-5">
        <Spinner color="primary"/>
      </div>
    </MarketCalculusCard>
  }

  return (
    <MarketCalculusCard>
      <div style={{ padding: 20 }}>
        <BlockHead size="sm">
          <BlockBetween className="center">
            <BlockHeadContent className="d-flex flex-col justify-center align-center">
              <BlockTitle className="center" tag="h5">
                {getCountryName(searchParams.countryToExport, countriesGSD, 'country_code')} - {t('worldTabs.thirdTabHeader')}
              </BlockTitle>
              <BadgeCode color="light" text={BADGE_CODES.SOURCE_TABLE_12}/>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        {currentTableData && <HsTradeTimeMatrix key="world-tab3-table" data={currentTableData}/>}
      </div>
    </MarketCalculusCard>
  )
}

export default SourceCountryThirdTab
